const STORAGE_KEY = 'mrx_shared_access_token';

const readPersistedToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem(STORAGE_KEY);
};

let accessToken: string | null = readPersistedToken();

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string | null): void => {
  accessToken = token;

  if (typeof window !== 'undefined') {
    if (token) {
      window.sessionStorage.setItem(STORAGE_KEY, token);
    } else {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};
